<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Solicitudes</span>
        </b-col>
        <b-col class="seccionCodigo">
          <p class="textoCodigo">{{codigoTitulo}}</p>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textoSubtitulo">{{ subTitulo }}</p>
      </div>

      <b-row v-if="$localStorageService.can('Bj_busqu_id_px')">
        <b-col>
          <b-row>
            <b-col>
              <div class="barra">
                <b-row>
                  <div class="col-sm-12 col-md-4 d-flex text-left">
                    <font-awesome-icon
                        style="color: #17a3b888"
                        class="m-auto m-1"
                        icon="filter"
                    />
                    <b-form-input
                        v-if="tipoBusqueda == 1"
                        class="ml-3 input-filter"
                        placeholder="ID del paciente"
                        v-model="idPaciente"
                    ></b-form-input>
                  </div>

                  <div class="col-sm-10 col-md-7 text-right">
                    <b-dropdown
                        variant="ligth"
                        id="dropdown-fechai"
                        :text="texFechaInicio"
                        class="btn-filter"
                    >

                      <b-calendar
                          class="m-2"
                          v-model="fechaInicio"
                          :max="new Date()"
                          @input="fechaMaxima($event)"
                      ></b-calendar>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item-button
                          class="text-right"
                          @click="limpiar(null, 'fechaInicio', null)"
                      >
                        <em class="fa fa-close"></em> Limpiar
                      </b-dropdown-item-button>
                    </b-dropdown>
                    <b-dropdown
                        variant="ligth"
                        id="dropdown-fechaf"
                        :text="texFechaFin"
                        class="btn-filter"
                    >
                      <b-calendar
                          class="m-2"
                          v-model="fechaFin"
                          :min="
                              fechaInicio === null
                                ? new Date()
                                : fechaInicio
                            "
                          :max="new Date()"
                      ></b-calendar>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item-button
                          class="text-right"
                          @click="limpiar(null, 'fechaFin', null)"
                      >
                        <em class="fa fa-close"></em> Limpiar
                      </b-dropdown-item-button>
                    </b-dropdown>
                  </div>
                  <div class="col-md-1  col-sm-12 text-right">
                    <span class="btn-clear" @click="limpiarFiltro()"><em class="fa fa-close"></em></span>
                    <b-button
                        style="background-color: #1B81AF; border-color:#1B81AF"
                        :disabled="loader"
                        @click="actualizarFechas(false)"
                    >
                        <span v-if="!loader"
                        ><font-awesome-icon icon="search"
                        /></span>
                      <span v-else><b-spinner small></b-spinner></span>
                    </b-button>
                  </div>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="slas !== undefined && datosTabla.length > 0">
        <b-col cols="12" style="text-align: right" v-if="slas.length > 0">
          <span class="mr-3"><strong>Estatus contacto PTI: </strong></span>
          <span v-for="sla in slas" :key="sla.idColor">
                <b-icon icon="circle-fill" aria-hidden="true" @click="filtrarSemaforo(sla)"
                        font-scale="1.5" :style="{color: sla.codigoColor}"
                        class="mr-4 semaforo"
                >
                </b-icon>
              </span>
          <span>
                <b-icon icon="x-circle" aria-hidden="true" @click="limpiarSemaforo"
                        font-scale="1.5" title="Limpiar filtro"
                        class="mr-4 semaforo"
                >
                </b-icon>
              </span>

        </b-col>
      </b-row>


      <b-row v-if="cifrasControl !== undefined">
        <b-col v-for="cifra in cifrasControl" :key="cifra.id">
          <br />
          <p class="letraMayusculaMinuscula" style="font-size: 13px">
            <b-icon style="color:orange; font-size: 18px" :icon="cifra.icono"></b-icon>
            {{ cifra.nombre }} {{ cifra.cantidad }}
          </p>
        </b-col>
      </b-row>

      <b-row v-if="cifrasControl !== undefined">
        <b-col cols="12">
          <br />
          <b-tabs v-model="indexTab">
            <template v-for="cifra in cifrasControl">
              <b-tab
                  style="font-size: 14px;"
                  :key="cifra.id"
                  :title="cifra.nombre"
                  @click="funcionExtraBandeja(cifra,0)"
                  v-if="
                        cifra.permiso !== undefined
                          ? $localStorageService.can(cifra.permiso)
                          : true
                      "
              >
                <div class="m-4">
                  <b-tabs pills align="right" style="background-color: white">
                    <template v-for="(tab, index) in cifra.subtabs">
                      <b-tab
                          title-link-class="tab"
                          :key="cifra.id + '-'+tab.id+'-'+index"
                          :title="tab.nombre"
                          @click="funcionExtraBandeja(cifra, tab.id)"
                      >
                      </b-tab>
                    </template>
                  </b-tabs>
                </div>
                <b-table
                    thead-tr-class="columnas"
                    :items="datosTabla"
                    :fields="cifra.layoutTabla"
                    :per-page="registrosPorPagina"
                    :current-page="1"
                    :small="true"
                    class="parrafos"
                    style="border-radius: 10px;"
                    responsive
                >
                  <template #cell()="data">
                    <div
                        :is="data.field.component"
                        :data="data"
                        @_funcionExtra="funcionExtraBandeja"
                        @_funcionExtra2="funcionExtra2Bandeja"
                        v-if="data.field.component !== undefined"
                        :resource="resource"
                    >lala</div>
                    <span v-else>{{ data.value }}</span>
                  </template>
                  <template v-slot:cell(nombreTipoSolicitudAnterior)="row">
                    <b-badge variant="primary">
                      {{ row.item.nombreTipoSolicitudAnterior }}
                    </b-badge>
                  </template>
                </b-table>
                <b-pagination
                    v-if="datosTabla !== undefined && totalRows >= 15"
                    align="center"
                    v-model="paginaActual"
                    :total-rows="totalRows"
                    :per-page="registrosPorPagina"
                    aria-controls="my-table1"
                ></b-pagination>
                <slot name="loader">

                </slot>
              </b-tab>
            </template>
          </b-tabs>

        </b-col>
      </b-row>



    </b-card>

  </div>
</template>

<script>
import Header from "@/components/Header";
import {MotorService} from "@/apiServices/motor/MotorService";

export default {
  name: "BandejaComponenteSolicitudes",

  components: { Header,},
  props: {
    icono: String,
    titulo: String,
    subTitulo: String,
    codigoTitulo: String,
    cifrasControl: Array,
    datosTabla: Array,
    resource: Object,
    slas: Array,
    nombreTab: String,
    totalRows: Number
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      motorServicio: new MotorService(),
      fechaInicio: "",
      fechaFin: "",
      idPaciente: null,
      paginaActual: 1,
      registrosPorPagina: null,
      update: 0,
      tipoBusqueda: 1,
      filtro: {
        estatusEtapa: [{ idEstatusEtapa: 1, descripcion: "Pendiente" }],
        estatus: [],
        clinicas: [],
        clasificaciones: null,
        nombre: null,
        fechaInicio: null,
        fechaFin: null,
        idPaciente: null,
      },
      search: {
        clinicaSearch: "",
        etapaSearch: "",
        clasificacionSearch: "",
      },
      loader: false,
      diasMaximoMes: null,
      max: null,
      tabIndex: 1,
      nombreTabSeleccionado:"",
      indexTab: 0,
      loaderBandeja: false
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.registrosPorPagina = this.$registrosPorPaginaTabla;
    this.indexTab = this.nombreTab;


  },
  watch: {
    fechaInicio(){
      if (this.fechaInicio === null){
        this.max =  new Date();
      }
      this.max =  this.fechaInicio.addDays(this.diasMaximoMes) > new Date() ? new Date(): this.fechaInicio.addDays(this.diasMaximoMes)

    },
    paginaActual(){
      this.actualizarFechas(true);
    }
  },

  mounted() {
  },
  methods: {
    fechaMaxima(event){
      this.diasMaximoMes = event.daysInMonth();
      this.fechaInicio = event;
      this.fechaFin = null;

    },
    maximo(){
      if (this.fechaInicio === null){
        return new Date();
      }
      return this.fechaInicio.addDays(this.diasMaximoMes) > new Date() ? new Date(): this.fechaInicio.addDays(this.diasMaximoMes)
    },
    obtenerDatos() {
      this.loader = true;
      const idEmpleado = this.$localStorageService.getIdEmpleado();
      this.motorServicio
          .obtenerTickets(idEmpleado, this.datosEnvio())
          .then((respuesta) => {
            this.registros = respuesta.data;
          })
          .finally(() => {
            this.loader = false;
          });
    },

    datosEnvio() {
      const envio = JSON.parse(JSON.stringify(this.filtro));

      if (this.filtro.fechaInicio !== null && this.filtro.fechaInicio != "") {
        let fechaActual = this.$moment(this.filtro.fechaInicio).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        });
        envio.fechaInicio = fechaActual
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      } else {

        envio.fechaInicio = null;
      }
      if (this.filtro.fechaFin !== null && this.filtro.fechaFin != "") {
        let fechaF = this.$moment(this.filtro.fechaFin).set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999,
        });
        envio.fechaFin = fechaF.utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      } else {

        envio.fechaFin = null;
      }
      if (this.filtro.clinicas.length > 0) {
        envio.clinicas = this.filtro.clinicas.map((t) => t.idClinica);
      } else {
        envio.clinicas = null;
      }
      if (this.filtro.estatus.length > 0) {
        envio.estatus = this.filtro.estatus.map((t) => t.id);
      } else {
        envio.estatus = null;
      }
      if (this.filtro.estatusEtapa.length > 0) {
        envio.estatusEtapa = this.filtro.estatusEtapa.map(
            (t) => t.idEstatusEtapa
        );
      } else {
        envio.estatusEtapa = null;
      }
      if (
          this.filtro.clasificaciones != null &&
          this.filtro.clasificaciones != ""
      ) {
        envio.clasificaciones = [this.filtro.clasificaciones.idClasificacion];
      } else {
        envio.clasificaciones = null;
      }
      if (this.tipoBusqueda == 1) {
        envio.idPaciente = null;
        envio.nombre = this.filtro.nombre;
        this.filtro.idPaciente = null;
      } else if (
          this.filtro.idPaciente != null &&
          this.filtro.idPaciente != ""
      ) {
        envio.idPaciente = this.filtro.idPaciente;
        envio.nombre = null;
        this.filtro.nombre = null;
      }
      return envio;
    },

    obtnerClinicas() {
      this.catalogoServicio.listaClinicas().then((response) => {
        this.clinicas = response;
      });
    },

    limpiar(search, atriburo, valor) {
      if (search != null) {
        this.search[search] = "";
      }
      this.filtro[atriburo] = valor;
    },
    limpiarFiltro() {
      this.idPaciente = null;
      this.fechaInicio = null;
      this.fechaFin = null;
    },


    funcionExtraBandeja(data,subtab) {

      if (subtab === 0 && data.subtabs != undefined &&data.subtabs != null && data.subtabs.length > 0){
        subtab = data.subtabs[0].id
      }


      this.$emit("_funcionExtra", data.id,subtab);
      //reiniciamos la pagina actual por que si no se queda con esta en memoria y marca errores
      //cuando hay pestañas que no tienen esa pagina
      //this.paginaActual = 1;
    },
    funcionExtra2Bandeja(data) {
      this.$emit("_funcionExtra2", data);
      //this.paginaActual = 1;
    },
    funcionExtra3Bandeja(data) {
      this.$emit("_funcionExtra3", data);
      //this.paginaActual = 1;
    },
    funcionExtra4Bandeja(data) {
      this.$emit("_funcionExtra4", data);
      //this.paginaActual = 1;
    },

    actualizarFechas(paginador) {
      var fechaI;
      var fechaF;
      if (this.fechaInicio !== '' && this.fechaFin !== ''){
        var dia1 = new Date(this.fechaInicio);
        dia1.setDate(dia1.getDate() + 1);
        dia1.setHours(0, 0, 0, 0);
        fechaI = this.$moment(dia1).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

        var dia2 = new Date(this.fechaFin);
        dia2.setDate(dia2.getDate() + 1);
        dia2.setHours(23, 60, 59, 999);
        fechaF = this.$moment(dia2).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      } else {
        fechaI = null;
        fechaF = null;
      }
      if(!paginador){
        this.paginaActual = 1;
      }

      this.$emit("_actualizaFecha", fechaI, fechaF, this.idPaciente, this.paginaActual);
    },
    filtrarSemaforo(sla){
      this.$emit("_filtrarSemaforo", sla);
      //this.paginaActual = 1;
    },
    limpiarSemaforo(){
      this.$emit("_limpiarSemaforo");
      //this.paginaActual = 1;
    }
  },

  computed: {
    clinicasFiltro() {
      return this.clinicas.filter((item) => {
        return item.strNombre
            .toLowerCase()
            .includes(this.search.clinicaSearch.toLowerCase());
      });
    },


    texClinica() {
      let text = "Clinicas";

      if (this.filtro.clinicas.length === 1) {
        text = this.filtro.clinicas[0].strNombre;
      }
      if (this.filtro.clinicas.length > 1) {
        text =
            this.filtro.clinicas[0].strNombre +
            " (" +
            (this.filtro.clinicas.length - 1) +
            "+" +
            ")";
      }
      return text;
    },

    texFechaInicio() {
      return this.fechaInicio === null || this.fechaInicio === ""
          ? "Fecha Inicio"
          : this.fechaInicio;
    },
    texFechaFin() {
      return this.fechaFin === null || this.fechaFin === ""
          ? "Fecha Fin"
          : this.fechaFin;
    },
  },

};
</script>
<style scoped>
.semaforo {
  transition: all .2s ease-in-out;
}

.semaforo:hover {
  transform: scale(1.5);
}
/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::*/
.scroll {
  max-height: 500px;
  overflow-y: auto;
}

.barra {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin: 1rem;
  padding: 5px;
  border-radius: 6px;
  text-align: left;
  align-items: center;
}

.row {
  background: transparent !important;
}

.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}
.contenedor-drop {
  overflow: auto;
  max-height: 15em;
}

label {
  font-weight: 100 !important;
}

.btn-clear {
  color: gray;
  position: relative;
  margin-right: 1em;
}
.btn-clear:hover {
  color: black;
  cursor: pointer;
}
.btn-clear:focus {
  color: black;
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}

</style>
